class StopCollection extends App.Collections.BaseCollection {
  url = "Stop";
  model = App.Models.Stop;

  getLengthRedeliverys = locationKey => {
    let totalRedelivery = 0;

    this.models.forEach(model => {
      const location = model.get("location");

      if(model.get("redeliveryStop") && location && location.key === locationKey) {
        totalRedelivery++;
      }
    });

    return totalRedelivery;
  };
}

App.Collections.Stops = StopCollection;
